<template>
 <div>
     <div class="row">
         <div class="col-md-12">
             <div class="sb-resources">
                 <img src="/images/resources-1.jpg" class="embed-responsive pl-3 pr-3 pb-2" alt="Resource image">
                 <div class="carousel-caption pl-2">
                     <h3>Running out of steam?</h3>
                     <p>
                         FIND OUT THE BEST TECHNIQUES<br/>
                         FOR ENDURANCE TRAINING
                     </p>
                     <div class="text-right">
                         <a href="#" target="_blank">View more</a>
                     </div>
                 </div>
             </div>
         </div>
     </div>
     <div class="row">
         <div class="col-md-12">
             <div class="sb-resources">
                 <img src="/images/resources-2.jpg" class="embed-responsive pl-3 pr-3 pb-2" alt="Resource image">
                 <div class="carousel-caption">
                     <h3>For your health</h3>
                     <p>
                         FIND OUT THE CORRECT WEIGHT<br/>
                         FOR YOUR WEIGHT
                     </p>
                     <div class="text-right">
                         <a href="">View more</a>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:[
            'env'
        ],
        mounted() {},

    }
</script>
